import { useState, useEffect } from 'react'

export default function useUploadTempImg(img) {

  const [dataImg, setDataImg] = useState();
  const [tempImg, setTempImg] = useState(); 

  useEffect(() => {
    setTempImg(img)
  }, [img])

  const getExtensionFile = (filename) => {
    const lastDotIndex = filename.lastIndexOf('.');
    if (lastDotIndex === -1) {
      return undefined;
    }
    return filename.slice(lastDotIndex + 1);
  }
  
  const uploadImg = event => {
    try {
      const fileUploaded = event.target.files[0];
      if (fileUploaded) {
        let ext = getExtensionFile(fileUploaded.name);
        if (ext && (ext === 'jpg' || ext === 'png' || ext === 'jpeg' || ext === 'webp')) {
          setDataImg(fileUploaded);
          const reader = new FileReader();
          reader.onload = ((e) => {
            const imageInfo = e;
            setTempImg(imageInfo.target.result);
          });
          reader.readAsDataURL(event.target.files[0]);
        }
      }
    } catch(err) {
      console.log(err);
    }
  };
  
  const deleteImg = () => {
    setDataImg();
    setTempImg();
  }  

  return { 
    dataImg,
    tempImg,
    uploadImg, 
    deleteImg
  }
}